import * as React from 'react'; // Import the 'React' module

import { ChatMessageMenuContext, ChatMessageMenuState } from './context';
import { TPosition } from '../../../types/messageContextMenu';

type TChatMenuProviderProps = {
  children: React.ReactNode;
};

export const ChatMessageMenuProvider: React.FC<TChatMenuProviderProps> = ({ children }) => {
  const [chatMessageMenuState, setChatMessageMenuState] = React.useState<ChatMessageMenuState | null>(null);

  const showChatMessageMenu = (chatId: string, messageId: string, position?: TPosition) => {
    setChatMessageMenuState({
      x: position?.x || 0,
      y: position?.y || 0,
      chatId,
      messageId,
    });
  };

  const hideChatMessageMenu = () => {
    setChatMessageMenuState(null);
  };

  React.useEffect(() => {
    document.addEventListener('click', hideChatMessageMenu);

    return () => {
      document.removeEventListener('click', hideChatMessageMenu);
    };
  }, []);

  const contextValue = React.useMemo(
    () => ({ chatMessageMenuState, showChatMessageMenu, hideChatMessageMenu }),
    [chatMessageMenuState],
  );

  return <ChatMessageMenuContext.Provider value={contextValue}>{children}</ChatMessageMenuContext.Provider>;
};
